import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import NotFound from '../views/404.vue'

Vue.use(VueRouter)

//路由重复 报错解决办法
// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this,location).catch(error => error)
// };

const routes = [
  {
    path: '/',
    redirect: { path: '/login' }
  },
  {
    path: '/login',
    // route level code-splitting                     
    // vue cli应用默认配置会为所有chunk.js设置预加载属性 对后台应用是合适的配置
    // this generates a separate chunk (about.[hash].js) for this route
 
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    name: 'login',
    meta: {
      title: 'ERP管理系统'
    }
  },
 
  //品质管理
  {
    path: '/qcmgt',
    component: Home,
    meta:{title:'品质管理'},
    redirect: { path: '/qcmgt/qc_notice' },
    children: [
      { path: 'qc_notice', component: () => import('../views/qcmgt/qc_notice.vue'), meta:{title:'品质异常通知单',keepAlive:true} },
      { path: 'mat_cancel', component: () => import('../views/qcmgt/mat_cancel.vue'), meta:{title:'报废申请单',keepAlive:true} },
      { path: 'mat_change', component: () => import('../views/qcmgt/mat_change.vue'), meta:{title:'4M变更通知单',keepAlive:true} },
      { path: 'prd_chkrpt', component: () => import('../views/qcmgt/prd_chkrpt.vue'), meta:{title:'成品检验报告',keepAlive:true} },
      { path: 'send_check', component: () => import('../views/qcmgt/send_check.vue'), meta:{title:'来料检验单',keepAlive:true} },
      { path: 'qc_report', component: () => import('../views/qcmgt/qc_report.vue'), meta:{title:'进料检验报告',keepAlive:true} },
      { path: 'bad_handle', component: () => import('../views/qcmgt/bad_handle.vue'), meta:{title:'不合格品处理记录',keepAlive:true} },
      { path: 'qc_check', component: () => import('../views/qcmgt/qc_check.vue'), meta:{title:'制程巡检记录',keepAlive:true} },
      { path: 'inner_rep', component: () => import('../views/qcmgt/inner_rep.vue'), meta:{title:'内审不符合报告',keepAlive:true} },
      { path: 'correct_rep', component: () => import('../views/qcmgt/correct_rep.vue'), meta:{title:'纠正预防措施报告',keepAlive:true} },
    ]
  },
 
  {
    path: '/get_forget',
    component: () => import('../views/base/Forget_Password.vue'),
    name: 'Forget_Password'
  },
  //注册账套
  {
    path: '/user_register',
    component: () => import('../views/base/Register.vue'),
    name: 'Register_User',
    meta: {
      title: 'ERP管理系统 | 注册用户'
    }
  },
  //考勤管理模块
  {
    path: '/cardmgt',
    component: Home,
    meta:{title:'考勤管理'},
    redirect: { path: '/cardmgt/emp_simple' },
    children: [
      { path: 'emp_simple', component: () => import('../views/cardmgt/emp_simple.vue'), meta:{title:'钉钉通讯录简表',keepAlive:true} },
      { path: 'card_list', component: () => import('../views/cardmgt/card_list.vue'), meta:{title:'钉钉打卡数据',keepAlive:true} },
      { path: 'leave_note', component: () => import('../views/cardmgt/leave_note.vue'), meta:{title:'请假申请单',keepAlive:true} },
    ]
  },
 
 
  {
    path: '/dashboard',
    component: Home,
    meta:{title:'HOME'},
    redirect: { path: '/dashboard/main' },
    children: [    //凡是使用Home作为一级路由view的二级路由，都默认使用tab页方式打开，keepAlive显示指定为true的tab页，将会被缓存在内存中；除非关闭这个tab页触发销毁
      { path: 'main', component: () => import(/* webpackChunkName: "main" */ '../components/SupplierWorkbench/DashboardMain.vue'), meta:{title:'我的面板',keepAlive:true} },
    ]
  },
  //基础数据模块
  {
    path: '/base',
    component: Home,
    meta:{title:'基础资料'},
    redirect: { path: '/base/base_dic' },
    children: [
      { path: 'base_dic', component: () => import('../views/base/Base_dic.vue'), meta:{title:'系统数据定义',keepAlive:true} },
      { path: 'hr_organize', component: () => import('../views/hrmgt/hr_organize.vue'), meta:{title:'组织架构',keepAlive:true} },
      { path: 'hr_employee', component: () => import('../views/hrmgt/hr_employee.vue'), meta:{title:'人员资料',keepAlive:true} },
      { path: 'bs_crcy', component: () => import('../views/base/bs_crcy.vue'),meta:{title:'币种维护',keepAlive:true} },
      { path: 'unit_mgt', component: () => import('../views/base/unit_mgt.vue'),meta:{title:'单位管理',keepAlive:true} },
      { path: 'prdtype_mgt', component: () => import('../views/base/Prdtype_mgt.vue'),meta:{title:'产品类别维护',keepAlive:true} },     
      { path: 'prd_attrib', component: () => import('../views/prdmgt/prd_attrib.vue'), meta:{title:'产品属性维护',keepAlive:true} },
      { path: 'mat_attrib', component: () => import('../views/prdmgt/mat_attrib.vue'), meta:{title:'物料属性维护',keepAlive:true} },
      { path: 'base_data', component: () => import('../views/base/base_data.vue'), meta:{title:'基础数据维护',keepAlive:true} },
    ]
  },
  //系统管理模块
  {
    path: '/sysmgt',
    component: Home,
    meta:{title:'系统模块'},
    redirect: { path: '/sysmgt/sys_mod' },
    children: [
      { path: 'sys_mod', component: () => import('../views/sysmgt/Sys_mod.vue'), meta:{title:'系统模块表单',keepAlive:true} },
      { path: 'sys_formfld', component: () => import('../views/sysmgt/Sys_formfld.vue'), meta:{title:'表单字段定义',keepAlive:true} },
      { path: 'sys_userpriv', component: () => import('../views/sysmgt/Sys_userpriv.vue'), meta:{title:'账号权限管理',keepAlive:true} },
      { path: 'sys_accdb', component: () => import('../views/sysmgt/sys_accdb.vue'), meta:{title:'账套管理',keepAlive:true} },
      { path: 'sale_chart', component: () => import('../views/sysmgt/sale_chart.vue'), meta:{title:'销售管理',keepAlive:true} },
      { path: 'std_joblib', component: () => import('../views/sysmgt/std_joblib.vue'), meta:{title:'标准工作库',keepAlive:true} },
      { path: 'stock_chart', component: () => import('../views/sysmgt/stock_chart.vue'), meta:{title:'仓库管理',keepAlive:true} },
      { path: 'flow_set', component: () => import('../views/sysmgt/flow_set.vue'), meta:{title:'审批流程设置',keepAlive:true} },
      { path: 'notice', component: () => import('../views/sysmgt/wait_work.vue'), meta:{title:'待跟进工作明细',keepAlive:true} },
      { path: 'flow_design', component: () => import('../views/sysmgt/flow_design.vue'), meta:{title:'流程设计',keepAlive:true} },
      { path: 'ord_chart', component: () => import('../views/sysmgt/ord_chart.vue'), meta:{title:'销售管理',keepAlive:true} },
    ]
  },
  //srm
  {
    path: '/srmmgt',
    component: Home,
    meta:{title:'协同管理'},
    redirect: { path: '/srmmgt/corp_info' },
    children: [
      { path: 'corp_info', component: () => import('../views/srmmgt/corp_info.vue'), meta:{title:'公司资料',keepAlive:true} },
      { path: 'prd_info', component: () => import('../views/srmmgt/prd_info.vue'), meta:{title:'产品资料',keepAlive:true} },
      { path: 'suppo_ord', component: () => import('../views/srmmgt/suppo_ord.vue'), meta:{title:'订单确认',keepAlive:true} },
      { path: 'req_ord', component: () => import('../views/srmmgt/req_ord.vue'), meta:{title:'报价单',keepAlive:true} },
      { path: 'po_paychk', component: () => import('../views/srmmgt/po_paychk.vue'), meta:{title:'对账单',keepAlive:true} },
      { path: 'po_send', component: () => import('../views/srmmgt/po_send.vue'), meta:{title:'采购送货单',keepAlive:true} },
      { path: 'outmat_in', component: () => import('../views/srmmgt/outmat_in.vue'), meta:{title:'委外物料签收',keepAlive:true} },
      { path: 'outmat_return', component: () => import('../views/srmmgt/outmat_return.vue'), meta:{title:'委外物料退货',keepAlive:true} },
      { path: 'mat_query', component: () => import('../views/srmmgt/mat_query.vue'), meta:{title:'委外物料库存查询',keepAlive:true} },
      { path: 'outmat_send', component: () => import('../views/srmmgt/outmat_send.vue'), meta:{title:'委外物料领料单',keepAlive:true} },
      { path: 'outmat_init', component: () => import('../views/srmmgt/outmat_init.vue'), meta:{title:'委外物料期初入库',keepAlive:true} },
      { path: 'outmat_check', component: () => import('../views/srmmgt/outmat_check.vue'), meta:{title:'委外物料盘点单',keepAlive:true} },
    ]
  },
  //仓库管理模块
  {
    path: '/stkmgt',
    component: Home,
    meta:{title:'库存管理'},
    redirect: { path: '/stkmgt/po_stkin' },
    children: [
      { path: 'po_stkin', component: () => import('../views/stkmgt/po_stkin.vue'), meta:{title:'质检入库单',keepAlive:true} },
      { path: 'stk_poout', component: () => import('../views/stkmgt/stk_poout.vue'), meta:{title:'采购退货单',keepAlive:true} },
      { path: 'prd_stklog', component: () => import('../views/stkmgt/prd_stklog.vue'), meta:{title:'实时库存查询',keepAlive:true} },
      { path: 'prd_stkinit', component: () => import('../views/stkmgt/prd_stkinit.vue'), meta:{title:'期初入库单',keepAlive:true} },
      { path: 'stk_othin', component: () => import('../views/stkmgt/stk_othin.vue'), meta:{title:'其它入库单',keepAlive:true} },
      { path: 'stk_othout', component: () => import('../views/stkmgt/stk_othout.vue'), meta:{title:'其它出库单',keepAlive:true} },
      { path: 'stk_trans', component: () => import('../views/stkmgt/stk_trans.vue'), meta:{title:'调拨单',keepAlive:true} },
      { path: 'stk_check', component: () => import('../views/stkmgt/stk_check.vue'), meta:{title:'盘点单',keepAlive:true} },
      { path: 'pc_pick', component: () => import('../views/prdmgt/pc_pick.vue'), meta:{title:'生产投料单',keepAlive:true} },
      { path: 'stk_prdout', component: () => import('../views/stkmgt/stk_prdout.vue'), meta:{title:'领料出库单',keepAlive:true} },
      { path: 'stk_prdrtn', component: () => import('../views/stkmgt/stk_prdrtn.vue'), meta:{title:'生产退料单',keepAlive:true} },
      { path: 'prd_in', component: () => import('../views/stkmgt/prd_in.vue'), meta:{title:'成品入库单',keepAlive:true} },
      { path: 'ww_prdin', component: () => import('../views/stkmgt/prdin_ww.vue'), meta:{title:'委外入库单',keepAlive:true} },
      { path: 'po_stkchk', component: () => import('../views/srmmgt/po_stkchk.vue'), meta:{title:'来料质检单',keepAlive:true} },
    ]
  },
  //人事管理模块
  {
    path: '/hrmgt',
    component: Home,
    meta:{title:'工作管理'},
    redirect: { path: '/hrmgt/emp_log' },
    children: [
      { path: 'emp_log', component: () => import('../views/hrmgt/emp_log.vue'), meta:{title:'个人工作日志',keepAlive:true} },  
      { path: 'job_plan', component: () => import('../views/sysmgt/job_plan.vue'), meta:{title:'工作计划跟进',keepAlive:true} },
      { path: 'tree_work', component: () => import('../views/hrmgt/tree_work.vue'), meta:{title:'项目列表',keepAlive:true} },
      { path: 'log_query', component: () => import('../views/hrmgt/log_query.vue'), meta:{title:'工作日志查询',keepAlive:true} },
      { path: 'work_sum', component: () => import('../views/hrmgt/work_sum.vue'), meta:{title:'工作日志汇总',keepAlive:true} },
    ]
  },
  //销售管理模块
  {
    path: '/ordmgt',
    component: Home,
    meta:{title:'销售管理'},
    redirect: { path: '/ordmgt/sale_ord' },
    children: [
      { path: 'sale_ord', component: () => import('../views/ordmgt/sale_ord.vue'), meta:{title:'销售订单',keepAlive:true} },
      { path: 'sale_preord', component: () => import('../views/ordmgt/sale_preord.vue'), meta:{title:'预测单',keepAlive:true} },
      { path: 'sale_out', component: () => import('../views/stkmgt/sale_out.vue'), meta:{title:'成品出库单',keepAlive:true} },
      { path: 'stk_salertn', component: () => import('../views/stkmgt/stk_salertn.vue'), meta:{title:'成品退货单',keepAlive:true} },
      { path: 'sale_receive', component: () => import('../views/ordmgt/sale_receive.vue'), meta:{title:'销售应收单',keepAlive:true} },
      { path: 'ar_check', component: () => import('../views/ordmgt/ar_check.vue'), meta:{title:'应收对账单',keepAlive:true} },
      { path: 'pack_list', component: () => import('../views/ordmgt/pack_list.vue'), meta:{title:'发运装箱单',keepAlive:true} },
      { path: 'sale_plan', component: () => import('../views/ordmgt/sale_plan.vue'), meta:{title:'销售计划',keepAlive:true} },
      { path: 'sale_chart', component: () => import('../views/ordmgt/sale_chart.vue'), meta:{title:'销售计划图表',keepAlive:true} },
      { path: 'clnt_research', component: () => import('../views/qcmgt/clnt_research.vue'), meta:{title:'客户满意度调查',keepAlive:true} },
      { path: 'dev_book', component: () => import('../views/ordmgt/dev_book.vue'), meta:{title:'客户资产登记',keepAlive:true} },
      { path: 'ord_audit', component: () => import('../views/ordmgt/ord_audit.vue'), meta:{title:'订单评审表',keepAlive:true} },
      { path: 'mat_quota', component: () => import('../views/ordmgt/mat_quota.vue'), meta:{title:'产品销售报价单',keepAlive:true} },
      { path: 'ord_sent', component: () => import('../views/ordmgt/ord_sent.vue'), meta:{title:'发货通知单',keepAlive:true} },
      { path: 'ord_notice', component: () => import('../views/qcmgt/ord_notice.vue'), meta:{title:'订单异常联络单',keepAlive:true} },
    ]
  },
  //采购管理模块
  {
    path: '/pomgt',
    component: Home,
    meta:{title:'采购管理'},
    redirect: { path: '/pomgt/po_prc' },
    children: [
      
      { path: 'po_ask', component: () => import('../views/pomgt/po_ask.vue'), meta:{title:'采购询价单',keepAlive:true} },
      { path: 'po_ord', component: () => import('../views/pomgt/po_ord.vue'), meta:{title:'采购订单',keepAlive:true} },
      { path: 'proc_query', component: () => import('../views/pomgt/proc_query.vue'), meta:{title:'采购进度查询',keepAlive:true} },
      { path: 'po_qrylist', component: () => import('../views/pomgt/po_qrylist.vue'), meta:{title:'采购对账单',keepAlive:true} },
      { path: 'po_req', component: () => import('../views/pomgt/po_req.vue'), meta:{title:'采购申请单',keepAlive:true} },
    ]
  },
  //pdf文件预览
  {
    path: '/fullPreview',
    component: () => import('../views/prdmgt/fullPreview.vue'),
    name: 'fullPreview',
    meta: {
      title: 'ERP管理系统 | 预览'
    }
  },
   //SKU MANAGEMENT
   {
    path: '/skumgt',
    component: Home,
    meta:{title:'SKU管理'},
    redirect: { path: '/skumgt/smp_stkin' },
    children: [
      { path: 'smp_return', component: () => import('../views/srmmgt/smp_return.vue'),meta:{title:'样品归还',keepAlive:true} },
      { path: 'smp_stklog', component: () => import('../views/srmmgt/smp_stklog.vue'),meta:{title:'样品库存查询',keepAlive:true} },
      { path: 'smp_stkin', component: () => import('../views/srmmgt/smp_stkin.vue'),meta:{title:'样品入库',keepAlive:true} },
      { path: 'smp_borrow', component: () => import('../views/srmmgt/smp_borrow.vue'),meta:{title:'样品借出',keepAlive:true} },
    ]
  },
  //产品管理模块
  {
    path: '/prodmgt',
    component: Home,
    meta:{title:'SKU管理'},
    redirect: { path: '/prodmgt/prd_datalib' },
    children: [
      { path: 'prd_datalib', component: () => import('../views/prdmgt/prd_datalib.vue'), meta:{title:'产成品',keepAlive:true} },
      { path: 'mat_datalib', component: () => import('../views/prdmgt/mat_datalib.vue'), meta:{title:'原材料',keepAlive:true} },
      { path: 'prd_smplib', component: () => import('../views/prdmgt/prd_smplib.vue'), meta:{title:'样板-模具-设计服务',keepAlive:true} },
      { path: 'sku_mgt', component: () => import('../views/base/sku_mgt.vue'),meta:{title:'SKU管理',keepAlive:true} },      
      { path: 'sku_barcode', component: () => import('../views/prdmgt/sku_barcode.vue'),meta:{title:'SKU二维码',keepAlive:true} },
      { path: 'motor_rep', component: () => import('../views/docmgt/motor_rep.vue'),meta:{title:'电机规格书',keepAlive:true} },
      { path: 'sku_asset', component: () => import('../views/base/sku_asset.vue'),meta:{title:'资产-模具',keepAlive:true} },
 
    ]
  },
  //工程生产
  {
    path: '/project',
    component: Home,
    meta:{title:'生产管理'},
    redirect: { path: '/project/bom_bill' },
    children: [
      { path: 'bom_bill', component: () => import('../views/prdmgt/bom_bill.vue'), meta:{title:'单层BOM表',keepAlive:true} },
      { path: 'tree_bom', component: () => import('../views/prdmgt/tree_bom.vue'), meta:{title:'树状BOM表',keepAlive:true} },
      { path: 'std_job', component: () => import('../views/prdmgt/std_job.vue'), meta:{title:'标准工序管理',keepAlive:true} },
      { path: 'mat_route', component: () => import('../views/prdmgt/prd_route.vue'), meta:{title:'工艺路线库',keepAlive:true} },
      { path: 'bom_cost', component: () => import('../views/prdmgt/bom_cost.vue'), meta:{title:'BOM成本',keepAlive:true} },
      { path: 'mat_request', component: () => import('../views/prdmgt/mat_request.vue'), meta:{title:'物料计划',keepAlive:true} },
      { path: 'work_task', component: () => import('../views/prdmgt/work_task.vue'), meta:{title:'生产任务单',keepAlive:true} },
      { path: 'out_product', component: () => import('../views/prdmgt/out_product.vue'), meta:{title:'委外加工单',keepAlive:true} },
      { path: 'mat_change', component: () => import('../views/qcmgt/mat_change.vue'), meta:{title:'4M变更通知单',keepAlive:true} },
      { path: 'job_time', component: () => import('../views/prdmgt/job_time.vue'), meta:{title:'生产日历',keepAlive:true} },
      { path: 'dev_fix', component: () => import('../views/prdmgt/dev_fix.vue'), meta:{title:'维修记录单',keepAlive:true} },
      { path: 'bom_compare', component: () => import('../views/prdmgt/bom_compare.vue'), meta:{title:'树状BOM对比',keepAlive:true} },
      { path: 'ord_process', component: () => import('../views/prdmgt/ord_process.vue'), meta:{title:'生产进度查询',keepAlive:true} },
      { path: 'mat_lock', component: () => import('../views/prdmgt/mat_lock.vue'),meta:{title:'物料锁库明细',keepAlive:true} },
      { path: 'prd_check', component: () => import('../views/prdmgt/prd_check.vue'),meta:{title:'在制品盘点',keepAlive:true} },
      { path: 'ord_report', component: () => import('../views/ordmgt/ord_report.vue'),meta:{title:'生产产量报工',keepAlive:true} },
      { path: 'dev_cap', component: () => import('../views/ordmgt/dev_cap.vue'),meta:{title:'设备产能',keepAlive:true} },
      { path: 'mat_suite', component: () => import('../views/project/mat_suite/index.vue'),meta:{title:'齐套料表',keepAlive:true} },
    ]
  },
  //客户管理模块
  {
    path: '/clntmgt',
    component: Home,
    meta:{title:'客户管理'},
    redirect: { path: '/clntmgt/cus_info' },
    children: [
      { path: 'cus_info', component: () => import('../views/clntmgt/cus_info.vue'), meta:{title:'客户资料',keepAlive:true} },
    ]
  },
  //供应商管理模块
  {
    path: '/supmgt',
    component: Home,
    meta:{title:'供应商管理'},
    redirect: { path: '/supmgt/sys_supinfo' },
    children: [
      { path: 'sys_supinfo', component: () => import('../views/supmgt/sys_supinfo.vue'), meta:{title:'供应商资料',keepAlive:true} },
      { path: 'sup_list', component: () => import('../views/supmgt/sup_list.vue'), meta:{title:'合格供应商一览表',keepAlive:true} },
      { path: 'po_analyze', component: () => import('../views/supmgt/po_analyze.vue'), meta:{title:'供应商采购分析',keepAlive:true} },
    ]
  },

  //研发管理
  {
    path: '/rdmgt',
    component: Home,
    meta:{title:'研发管理'},
    redirect: { path: '/rdmgt/new_prd' },
    children: [
      { path: 'new_prd', component: () => import('../views/qcmgt/new_prd.vue'), meta:{title:'产品开发建议书',keepAlive:true} },
      { path: 'bom_init', component: () => import('../views/qcmgt/bom_init.vue'), meta:{title:'初始BOM清单',keepAlive:true} },
      { path: 'design_rpt', component: () => import('../views/qcmgt/design_rpt.vue'), meta:{title:'设计评审报告',keepAlive:true} },
      { path: 'try_notice', component: () => import('../views/qcmgt/try_notice.vue'), meta:{title:'试产通知单',keepAlive:true} },
      { path: 'try_report', component: () => import('../views/qcmgt/try_report.vue'), meta:{title:'试产总结报告',keepAlive:true} },
    ]
  },
  //财务管理
  {
    path: '/finmgt',
    component: Home,
    meta:{title:'财务管理'},
    redirect: { path: '/finmgt/inv_mgt' },
    children: [
      { path: 'inv_mgt', component: () => import('../views/finmgt/invoice_mgt.vue'), meta:{title:'发票管理',keepAlive:true} },
      { path: 'inv_subject', component: () => import('../views/finmgt/inv_subject.vue'), meta:{title:'科目类别维护',keepAlive:true} },
      { path: 'cashno', component: () => import('../views/finmgt/cashno.vue'), meta:{title:'资金账户维护',keepAlive:true} },
      { path: 'inv_daily', component: () => import('../views/finmgt/inv_daily.vue'), meta:{title:'现金日记账',keepAlive:true} },
      { path: 'inv_bank', component: () => import('../views/finmgt/inv_bankday.vue'), meta:{title:'银行日记账',keepAlive:true} },
      { path: 'inv_mthchk', component: () => import('../views/finmgt/inv_mthchk.vue'), meta:{title:'期未结账',keepAlive:true} },
      { path: 'inv_bankchk', component: () => import('../views/finmgt/inv_bankchk.vue'), meta:{title:'银行对账',keepAlive:true} },
      { path: 'type_inout', component: () => import('../views/base/type_inout.vue'),meta:{title:'收支类别维护',keepAlive:true} },
      { path: 'project_fee', component: () => import('../views/finmgt/project_fee.vue'),meta:{title:'项目费用报销',keepAlive:true} },
      { path: 'consume_mgt', component: () => import('../views/finmgt/consume_mgt.vue'),meta:{title:'报销-管理摊分',keepAlive:true} },
      { path: 'paychk_seyas', component: () => import('../views/finmgt/paychk_seyas.vue'),meta:{title:'马迅-西雅斯对账',keepAlive:true} },
      { path: 'paychk_glps', component: () => import('../views/finmgt/paychk_glps.vue'),meta:{title:'歌蕾佩斯应付对账',keepAlive:true} },
      { path: 'seyas_pay', component: () => import('../views/finmgt/seyas_pay.vue'),meta:{title:'西雅斯代付',keepAlive:true} },
      { path: 'check_pay', component: () => import('../views/finmgt/check_pay.vue'),meta:{title:'对账-支付',keepAlive:true} },
      { path: 'asset_config', component: () => import('../views/finmgt/asset_config.vue'),meta:{title:'资金配置表',keepAlive:true} },
      
    ]
  },
  //文档管理模块
  {
    path: '/docmgt',
    component: Home,
    meta:{title:'文档管理'},
    children: [
      { path: 'info_issue', component: () => import('../views/docmgt/info_issue.vue'), meta:{title:'信息发布',keepAlive:true} },
      { path: 'info_detail', component: () => import('../views/docmgt/info_detail.vue'), meta:{title:'系统文档库',keepAlive:true} },
      { path: 'doc_detail', component: () => import('../views/docmgt/doc_detail.vue'), meta:{title:'文档详情',keepAlive:true} },
      { path: 'train_rec', component: () => import('../views/docmgt/train_rec.vue'), meta:{title:'员工培训记录',keepAlive:true} },
      { path: 'emp_sign', component: () => import('../views/docmgt/emp_sign.vue'), meta:{title:'员工培训签到',keepAlive:true} },
      { path: 'file_list', component: () => import('../views/docmgt/file_list.vue'), meta:{title:'文件管制一览表',keepAlive:true} },
      { path: 'file_send', component: () => import('../views/docmgt/file_send.vue'), meta:{title:'文件分发记录',keepAlive:true} },
      { path: 'file_check', component: () => import('../views/docmgt/file_check.vue'), meta:{title:'文件分发签收',keepAlive:true} },
      { path: 'mail_addr', component: () => import('../views/docmgt/mail_addr.vue'), meta:{title:'邮件地址薄',keepAlive:true} },
      { path: 'mail_send', component: () => import('../views/docmgt/mail_send.vue'), meta:{title:'发件箱',keepAlive:true} },
      { path: 'mail_receive', component: () => import('../views/docmgt/mail_receive.vue'), meta:{title:'收件箱',keepAlive:true} },
    ]
  }, 
  //我的数据集
  {
    path: '/mydata',
    component: Home,
    meta:{title:'亚马逊运营'},
    children: [
      { path: 'manage_sum', component: () => import('../views/clntmgt/amz_import.vue'), meta:{title:'数据导入',keepAlive:true} },
      { path: 'operate_sum', component: () => import('../views/clntmgt/operate_sum.vue'), meta:{title:'经营汇总',keepAlive:true} },
      { path: 'subject', component: () => import('../views/finmgt/amz_subject.vue'), meta:{title:'亚马逊科目维护',keepAlive:true} },
      { path: 'return_sum', component: () => import('../views/clntmgt/return_ana.vue'), meta:{title:'退货数据分析',keepAlive:true} },
      { path: 'skumgt', component: () => import('../views/finmgt/amz_skumgt.vue'), meta:{title:'SKU维护',keepAlive:true} },
      { path: 'amz_stkchk', component: () => import('../views/clntmgt/amz_stkchk.vue'), meta:{title:'亚马逊库存明细',keepAlive:true} },
      { path: 'stk_change', component: () => import('../views/clntmgt/stk_change.vue'), meta:{title:'店铺库存调整表',keepAlive:true} },
      { path: 'sku_init', component: () => import('../views/clntmgt/sku_init.vue'), meta:{title:'SKU期初数据',keepAlive:true} },
      { path: 'amz_rule', component: () => import('../views/base/amz_rule.vue'), meta:{title:'亚马逊数据基础规则',keepAlive:true} },
      { path: 'sku_profit', component: () => import('../views/finmgt/sku_profit.vue'), meta:{title:'SKU利润测算',keepAlive:true} },
    ]
  },
  {
    path: '/404',
    component: NotFound,
    name: '404'
  },
  {
    path: '*',
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  mode: 'history',  //建议使用history模式 ,hash 
  base: process.env.BASE_URL,

  routes//:[{ path: '*', component: NotFound }]
})

export default router
